export const EDIT_PROFILE_STEPS = ['basics', 'insurance', 'tax', 'bio'];
